export const loadingTypes = {
  line: 'line'
};
